import type { Pass } from '../types/pass'
import { passTitle } from '../lib/pass-ui'

import { PassAvailableRewardCard } from './PassAvailableRewardCard'
import { PassHero } from './PassHero'
import { PassObjectivesCard } from './PassObjectivesCard'
import { PassRewardTrail } from './PassRewardTrail'

interface PassCardProps {
  pass: Pass
}

export function PassCard({ pass }: PassCardProps) {
  return (
    <article className="flex w-full max-w-[940px] flex-col gap-5">
      <header className="px-1">
        <h2 className="text-[1.75rem] font-black tracking-[-0.03em] text-white sm:text-[2.65rem]">
          {passTitle(pass)}
        </h2>
      </header>
      <PassHero pass={pass} />
      <PassObjectivesCard pass={pass} />
      <PassAvailableRewardCard pass={pass} />
      <PassRewardTrail pass={pass} />
    </article>
  )
}
